import { Stack, Box, Link, Button, Divider, IconButton } from "@mui/material"
import { SendInvoiceByMailCommand, SendInvoiceReminderByMailCommand, SendReverseInvoiceByMailCommand } from '../../GeneratedClients/FreeBillApi'
import { MouseEvent, useState } from "react"
import { TextInput, email, required, useNotify, useRecordContext } from "react-admin"
import { useMutation } from "react-query";
import { apiService } from "../../apiService";
import fileDownload from "js-file-download";
import { AttachFile, Close } from "@mui/icons-material"
import { TextArrayInput } from "../TextArrayInput";

interface IProps {
  attachments?: {id?: string, attachmentFileName: string, resource: "invoices" | "reverseInvoices" | "invoiceReminders"}[]
}

const EmailPreview = ({attachments}: IProps) => {

  const record: SendInvoiceByMailCommand | SendReverseInvoiceByMailCommand | SendInvoiceReminderByMailCommand = useRecordContext()
  const notify = useNotify()
  const [cc, setCc] = useState<boolean>(false)
  const [bcc, setBcc] = useState<boolean>(false)


  const mutationFunction = async (id:string, fileName: string, resource: "invoices" | "reverseInvoices" | "invoiceReminders") => {
    var data: {file?: any, fileName: string} = {fileName: fileName}
    switch (resource) {
      case "invoices":
        data.file = await apiService.InvoicesApi.downloadPdf({id: id}, {responseType: 'blob'})
        return data    
      case "reverseInvoices":
        data.file = await apiService.ReverseInvoicesApi.downloadReverseInvoice({id: id}, {responseType: 'blob'})  
        return data
      case "invoiceReminders":
        data.file = await apiService.InvoiceRemindersApi.downloadInvoiceReminder({id: id}, {responseType: 'blob'})
        return data
      default:
        break
    }
  }

  const { mutate:downloadResourceFile, isLoading } = useMutation((params:{id: string, fileName:string, resource:"invoices" | "reverseInvoices" | "invoiceReminders"}) => mutationFunction(params.id, params.fileName, params.resource),
    {
      onSuccess: (data) => {
        var pdfFile: any = data?.file.data
        fileDownload(pdfFile, `${data?.fileName}`)
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )

  const handleClick = (e:MouseEvent, fileName:string, resource: "invoices" | "reverseInvoices" | "invoiceReminders", id?:string) => {
    e.preventDefault()
    if(id) downloadResourceFile({id, fileName, resource})
  }

  const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
  const validateToAddresses = (value?: string[]) => {
    if(value?.some((x:string) => EMAIL_REGEX.test(x) === false))
      return "ra.validation.email"
    return undefined
  }

  return (
    <Stack px={6} py={2} spacing={0}>
      <Box sx={{mb:2}} display={"flex"} justifyContent={"flex-end"}>
        {
          attachments?.map((attachment, i) => 
            <Box mx={1} key={i}>
              <AttachFile fontSize="small" sx={{mr: 1}} />
              <Link
                sx={{cursor: 'pointer'}}
                onClick={(e) => handleClick(e, attachment.attachmentFileName, attachment.resource, attachment.id)}
              >  
                {attachment.attachmentFileName}
              </Link>
            </Box>
          )
        }
        <Divider orientation="vertical" sx={{py:2, px: 1}} />
        <Box mx={1} >
          <Button onClick={() => setCc(true)} size="small" disabled={cc}>Kopie (CC)</Button>
          <Button onClick={() => setBcc(true)} sx={{ml: 1}} size="small" disabled={bcc}>Blindkopie (BCC)</Button>
        </Box>
      </Box>
      <Box>
        <TextInput 
          disabled 
          sx={{m:0}} 
          size="small" 
          fullWidth 
          source="fromAddress" 
          label={`Von ${record.fromName}`}
          validate={[required(), email()]}
        />
      </Box>
      <Box>
        <TextArrayInput 
          sx={{m:0}} 
          size="small" 
          fullWidth 
          source="toAddresses" 
          label={`An ${record.toName}`} 
          validate={[required(), validateToAddresses]}
        />
      </Box>
      {
        cc && 
        <Box display={"flex"} alignItems={"center"}>
          <IconButton onClick={() => setCc(false)} size="small" sx={{p:2, mb: 2, mr:1, height: 20, width: 20}} ><Close fontSize="small" /></IconButton>
          <TextArrayInput 
            sx={{m:0}} 
            size="small" 
            fullWidth 
            source="toCCAddresses" 
            label={`Kopie (CC)`} 
            validate={validateToAddresses}
          />
        </Box>
      }
      {
        bcc &&
        <Box display={"flex"} alignItems={"center"}>
          <IconButton onClick={() => setBcc(false)} size="small" sx={{p:2, mb: 2, mr:1, height: 20, width: 20}} ><Close fontSize="small" /></IconButton>
          <TextArrayInput 
            sx={{m:0}} 
            size="small" 
            fullWidth 
            source="toBCCAddresses" 
            label={`Blindkopie (BCC)`} 
            validate={validateToAddresses}
          />
        </Box>
      }
      <Box>
        <TextInput 
          sx={{m:0}} 
          size="small" 
          fullWidth 
          source="subject" 
          label={`Betreff`}
        />
      </Box>
      <Box>
        <TextInput 
          label={'Nachricht'}
          size="small" 
          source="emailText"
          sx={{whiteSpace: 'pre-line'}}
          fullWidth
          multiline
          rows={12}
        />
      </Box>
    </Stack>
  )
}

export default EmailPreview